export default __webpack_public_path__ + "static/media/gamefi.218acc00.webp";